export enum Seller {
  SELLER_1 = 'SELLER_1',
  SELLER_2 = 'SELLER_2',
  SELLER_3 = 'SELLER_3',
}

export interface SellerInfo {
  id: Seller;
  name: string;
  tmId: string;
  salesRoute: string;
  customers?: SellerCustomer[];
}

export interface SellerCustomer {
  id: string;
  name: string;
  subtitle?: string;
}

// Mock data for seller filter
export const mockSellers: SellerInfo[] = [
  {
    id: Seller.SELLER_1,
    name: 'Name 1',
    tmId: 'TM001',
    salesRoute: 'Sales Route 1',
    customers: [
      { id: 'customer1', name: 'Customer 1', subtitle: 'Title2 here' },
      { id: 'customer2', name: 'Customer 2', subtitle: 'Title2 here' },
      { id: 'customer3', name: 'Customer 3', subtitle: 'Title2 here' },
    ],
  },
  {
    id: Seller.SELLER_2,
    name: 'Name 2',
    tmId: 'TM002',
    salesRoute: 'Sales Route 2',
    customers: [
      { id: 'customer4', name: 'Customer 4', subtitle: 'Title2 here' },
      { id: 'customer5', name: 'Customer 5', subtitle: 'Title2 here' },
    ],
  },
  {
    id: Seller.SELLER_3,
    name: 'Name 3',
    tmId: 'TM003',
    salesRoute: 'Sales Route 3',
    customers: [
      { id: 'customer6', name: 'Customer 6', subtitle: 'Title2 here' },
      { id: 'customer7', name: 'Customer 7', subtitle: 'Title2 here' },
    ],
  },
];
